import { gql, TypedDocumentNode } from '@common/hooks';
import {
  CreateSpearfishingCampaignMutationCgResponse,
  CreateSpearfishingCampaignMutationVariables,
} from '@common/graphql/schema';

export const CREATE_SPEARFISHING_CAMPAIGN: TypedDocumentNode<
  CreateSpearfishingCampaignMutationCgResponse,
  CreateSpearfishingCampaignMutationVariables
> = gql`
  mutation CreateSpearfishingCampaign(
    $workerIds: [ID!]
    $shiftGapId: ID!
    $message: String!
    $groupIds: [ID!]
    $messageType: SpearfishingMessageType!
  ) {
    createSpearfishingCampaign(
      workerIds: $workerIds
      shiftGapId: $shiftGapId
      message: $message
      groupIds: $groupIds
      messageType: $messageType
    ) {
      id
    }
  }
`;
